import React from 'react';
import type { LeadIssueChip } from '../../types';

const SEVERITY_COLORS: Record<string, { bg: string; fg: string }> = {
  mild:   { bg: '#fef3c7', fg: '#92400e' },
  medium: { bg: '#ffedd5', fg: '#9a3412' },
  strong: { bg: '#fee2e2', fg: '#991b1b' },
};

const categoryLabel = (category: string): string =>
  category.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');

/**
 * Phase 3.6 — open issue chips on the lead header. One chip per open
 * lead_issues row (a set, unique per lead+category — so this list is
 * naturally deduplicated already).
 */
const IssueChips: React.FC<{ issues?: LeadIssueChip[] }> = ({ issues }) => {
  const open = (issues ?? []).filter(i => i.status === 'open');
  if (open.length === 0) return null;

  return (
    <>
      {open.map(issue => {
        const c = SEVERITY_COLORS[issue.severity] ?? SEVERITY_COLORS.mild;
        return (
          <span
            key={issue.id}
            title={issue.evidence_text ?? categoryLabel(issue.category)}
            style={{
              display: 'inline-flex', alignItems: 'center',
              background: c.bg, color: c.fg, borderRadius: 999,
              padding: '2px 8px', fontSize: 11, fontWeight: 600,
              lineHeight: 1.2, letterSpacing: 0.2, userSelect: 'none',
            }}
          >
            {categoryLabel(issue.category)}
          </span>
        );
      })}
    </>
  );
};

export default IssueChips;
